import type {Product} from '@/types/product';


export const brandName = () => {
	return import.meta.env.VITE_DFN_BRAND ?? 'DFN';
};

export const loggerBrandPrefix = () => {
	return `[${brandName().toUpperCase()}]`;
};

export const dataLayerPush = (payload: unknown) => {
	const dataLayerLoaded = typeof window.dataLayer !== 'undefined';
	const loggerPrefix = loggerBrandPrefix();

	if (!payload) {
		console.warn(`${loggerPrefix} Nothing to push`);
		return;
	}

	if (dataLayerLoaded) {
		window.dataLayer.push(payload);
	} else {
		console.log(`${loggerPrefix} DATALAYER NOT LOADED, SHOWING OBJECT THAT SHOULD BE PUSHED:`);
		console.dir(payload);
	}
};

export const dataLayerComposeProduct = (product: Product) => {
	const areaId = window.composeOrderDecoratorJson?.areaId;

	if (!areaId) {
		console.error(`${loggerBrandPrefix()} No areaId defined`);
	}

	return {
		name: product.title,
		id: product.internalKey,
		price: product.price,
		brand: brandName(),
		category: 'Expansie',
		quantity: product.amountOrdered,
		dimension1: areaId,
		dimension2: 'Expansie'
	};
};

export const dataLayerSentrySettings = () => {
	const sentrySettings = window.sentrySettings;

	if (!sentrySettings) {
		console.error(`${loggerBrandPrefix()} No sentrySettings defined`);
		return {
			dsn: undefined,
			environment: undefined,
			release: undefined
		};
	}

	return sentrySettings;
};
